import { PublicClientApplication } from '@azure/msal-browser'

let msalInstance = null
const INTERACTION_REQUIRED_ERROR_CODES = ['interaction_required', 'consent_required', 'login_required']
const DEFAULT_ENTRA_TENANT_ID = '548d26ab-8caa-49e1-97c2-a1b1a06cc39c'
const DEFAULT_ENTRA_AUTHORITY = `https://login.microsoftonline.com/${DEFAULT_ENTRA_TENANT_ID}`
const DEFAULT_REDIRECT_URI = 'http://localhost:3000'

function resolveEntraConfig() {
  const config = (typeof window !== 'undefined' && window.config && window.config.entraAuth) || {}

  const clientId = config.clientId || process.env.REACT_APP_ENTRA_CLIENT_ID
  const tenantId = config.tenantId || process.env.REACT_APP_ENTRA_TENANT_ID || DEFAULT_ENTRA_TENANT_ID
  const authority = config.authority
    || (tenantId ? `https://login.microsoftonline.com/${tenantId}` : undefined)
    || process.env.REACT_APP_ENTRA_AUTHORITY
    || DEFAULT_ENTRA_AUTHORITY

  const redirectUri = config.redirectUri || process.env.REACT_APP_ENTRA_REDIRECT_URI || DEFAULT_REDIRECT_URI
  const scopes = config.scopes || ['openid', 'profile', 'email']

  return {
    clientId,
    authority,
    redirectUri,
    scopes,
    cacheLocation: config.cacheLocation || 'localStorage',
    storeAuthStateInCookie: Boolean(config.storeAuthStateInCookie),
  }
}

export function isEntraConfigured() {
  const config = resolveEntraConfig()
  return Boolean(config.clientId)
}

export function getLoginRequest() {
  const config = resolveEntraConfig()
  return { scopes: config.scopes }
}

function isInteractionRequiredError(error) {
  const code = error && (error.errorCode || error.code)
  return Boolean(code && INTERACTION_REQUIRED_ERROR_CODES.includes(String(code).toLowerCase()))
}

export function getMsalInstance() {
  if (!isEntraConfigured()) {
    return null
  }

  if (!msalInstance) {
    const config = resolveEntraConfig()
    msalInstance = new PublicClientApplication({
      auth: {
        clientId: config.clientId,
        authority: config.authority,
        redirectUri: config.redirectUri,
      },
      cache: {
        cacheLocation: config.cacheLocation,
        storeAuthStateInCookie: config.storeAuthStateInCookie,
      },
    })
  }

  return msalInstance
}

export function getActiveAccount() {
  const msal = getMsalInstance()
  if (!msal) {
    return null
  }

  return msal.getActiveAccount() || msal.getAllAccounts()[0] || null
}

export async function acquireAuthToken({ interactive = false, scopes } = {}) {
  const msal = getMsalInstance()
  if (!msal) {
    return null
  }

  const account = getActiveAccount()
  if (!account) {
    return null
  }

  const request = {
    account,
    scopes: scopes || getLoginRequest().scopes,
  }

  try {
    const response = await msal.acquireTokenSilent(request)
    return response && (response.accessToken || response.idToken) ? (response.accessToken || response.idToken) : null
  } catch (error) {
    if (interactive && isInteractionRequiredError(error)) {
      const response = await msal.acquireTokenPopup({ scopes: request.scopes })
      return response && (response.accessToken || response.idToken) ? (response.accessToken || response.idToken) : null
    }

    return null
  }
}
